export default {
    url: '/manage',
    template: `
        <ui-view></ui-view>
    `,
    data: {
        canAccess: (AuthService, PrivilegeService) => {
            return PrivilegeService.isCompanyAdmin();
        }
    },
    abstract: true,
    controller ($state, PrivilegeService) {
        this.$state = $state;
        this.PrivilegeService = PrivilegeService;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/index.js